export default __webpack_public_path__ + "static/media/botProfile.6bd4c4f4.png";